export const LABELS_REPORTS = {
	
	reports: 'Звіти',
	readyReports: 'Готові звіти',
	reportBuilder: 'Конструктор звітів',
	reportReceived: 'Прийняті дані',
	reportScheduleExecution: 'Звіт про роботу маршруту',
	reportScheduleExecutionByRoutes: 'Звіт про роботу маршруту(групування по маршрутам)',
	reportVoyagePointData: 'Звіт про відвідання зупинок',
	reportGroupMileage: "Денний звіт пробігу",
	reportDevicePlanningExecution: "Звіт про планування та виконання маршрутів(по об'єктам)",
	reportGroupMileageTitle: "Звіт про виконану транспортну роботу на маршрутах",
	reportFuelConsumption: 'Звіт про споживання палива',
	reportFuelConsumptionByDevice: 'Звіт про споживання палива(окремо по кожному об\'єкту)',
	reportFuelConsumptionByRoute: 'Звіт про споживання палива(по маршруту в цілому)',
	reportGroupActiveSession: 'Звіт про активність об\'єктів',
	prevVoyagePoint: 'Попередня геозона',
	reportIccids:'Звіт ICCID пристроїв',
	gap: 'Час від попередньої геозони',
	reportVoyagePointAverages: 'Звіт про відвідування зупинок(узагальнений)',
	reportCarWashGeoZoneVisits: 'Звіт про відвідування мийок',
	reportMileageSummary: 'Пробіг по групі за період',
	reportTrackerOutages: 'Звіт про обриви трекерів',
	trackerOutages: {
		gapMinutes: 'Поріг втрати зв\'язку, хв',
		noFixMinutes: 'Поріг без позиції, хв',
		type: 'Тип обриву',
		typeNoConnection: 'Немає зв\'язку',
		typeSpoofing: 'Підміна координат',
		typeNoSatellites: 'Немає супутників',
		typeNoGpsFix: 'Немає GPS-фіксації',
		startTime: 'Початок',
		endTime: 'Кінець',
		duration: 'Тривалість',
		lastPoint: 'Зник біля',
		resumePoint: 'Виринув біля',
		displacementKm: 'Зміщення по прямій, км',
		movingBefore: 'Рухалась перед обривом',
		movedDuringOutage: 'Змістилась під час обриву',
		outageCount: 'Обривів',
		countByType: 'По типах',
		totalSilentMinutes: 'Без зв\'язку',
		totalBlindMinutes: 'Без позиції',
		longestOutageMinutes: 'Найдовший обрив',
		totalDisplacementKm: 'Сумарне зміщення',
		coveragePercent: 'Покриття',
		withoutOutages: 'Обривів не виявлено',
		ongoing: 'триває',
		beforePeriod: 'почався до початку періоду',
		unknown: 'невідомо',
		lessThanMinute: '< 1 хв',
		hoursShort: 'год',
		minutesShort: 'хв',
		kmShort: 'км',
	},
	odometerStart: 'Одометр (поч.), км',
	odometerEnd: 'Одометр (кін.), км',
	drivers: 'Водії',
	daysOnRoute: 'Днів на маршруті',
	BatV: 'Бат V',
	BortV: 'Борт V',
	reportErrors: 'Помилки',
	bak: 'Бак',
	time: 'Час',
	mileage: 'Пробіг',
	startVoyage: 'На початку випуску',
	endVoyage: 'Вкінці випуску',
	start: 'На початку',
	end: 'Вкінці',
	fuelDiff: 'Палива витрачено, л',
	fuelExpense: 'Витрата палива, л /100 км',
	fuelLevel: 'Палива в баку, л',
	ignition: 'Запалювання',
	reportLabels: 'Має датчик палива',
	reserveBattery: 'Резервний акумулятор',
	selectDevice: "Для отримання даних оберіть ТЗ",
	selectDeviceAndAccount: "Для отримання даних оберіть тз та перевізника",
	licensePlate: "ТЗ",
	driverName: "Водій",
	startTimeVoyage: "Час початку випуску",
	endTimeVoyage: "Час кінця випуску",
	odometerStartVoyage: "Пробіг на початок випуску",
	odometerEndVoyage: "Пробіг на кінець випуску",
	durationRoute: "Час виконання маршруту",
	voyageOrder: "Випуск",
	fuelStartLevelVoyage: "Паливо на початок випуску",
	fuelEndLevelVoyage: "Паливо на кінець випуску",
	fuelLevelDelta: "Витрата палива",
	routeName: "Маршрут",
	totalFuelConsumption: "Витрата палива з заправками/зливами",
	consumptionPer100Km: "Розхід на 100км",
	onlySkippedPointShow: "Показувати тільки пропущені зупинки",
	accountName: "Перевізник",
	filledFuel: "Заправлено",
	drainedFuel: "Злито",
	fillCount: "К-сть заправок",
	drainCount: "К-сть зливів",
	voyagePoint: "Геозона",
	scheduleArrivalTime: "Плановий час прибуття",
	realArrivalTime: "Фактичний час прибуття",
	departureTime: "Час відбуття",
	voyageName: "Назва маршруту",
	longScheduleName: "Випуск, Оберт",
	skippedPoint: "Пропущена зупинка",
	percentPointsPassedInTime: "Графічність",
	mileageRouteFact: "Пробіг на мар., км",
	totalDailyMileage: "Дений пробіг, км",
	fromStop: "Від",
	toStop: "До",
	samples: "Samples",
	avg: "Тривалість",
	errorMessages: {
		errorAccount: 'У вас немає доступу до Перевізнику',
		errorGroup: 'У вас немає доступу до групи',
		errorType: 'Даного типу запиту не існує..',
		errorDateFormat: 'Не вірний формат дати',
		errorDevices: 'У вас немає доступу до девайсу',
	}
	
}